import { getDeviceInfo } from "./getDeviceInfo";
import { hDtEnum } from "./types/enum";
const banWebBounces = () => {
  getDeviceInfo().then((res) => {
    if (res.h_dt === hDtEnum.ios) {
      window.HiyaJSBridge.callHandler("banWebBounces");
    }
  });
};
export {
  banWebBounces
};
